import { isNoteTextBlank } from "./is-note-text-blank";

/** What a note is made of, from the point of view of "is there anything here". */
interface NoteContent {
	/** The note's text, as the editor serialised it. */
	note?: string | null;
	/** How many files the note carries — uploaded with it, or picked from what is already there. */
	fileCount?: number;
}

/**
 * Whether a note carries anything worth writing: words, or at least one file.
 *
 * **A note is text or attachments, and needs only one of the two.** A photograph of a blocked
 * access route says what it needs to on its own, so requiring a sentence beside it only produced
 * notes reading "siehe Bild". Neither is still nothing, and that is the one case both clients hide
 * their send button for and the server refuses.
 *
 * The single definition of that rule, shared by the server guard and by both clients' note forms,
 * so a form cannot offer a write the handler declines.
 *
 * @param content - The note's text and the number of files going with it.
 * @returns True when the note has text, files, or both.
 */
export function hasNoteContent({ note, fileCount = 0 }: NoteContent): boolean {
	return !isNoteTextBlank(note) || fileCount > 0;
}
